export function typesenseServerConfig({ apiKey, host, port, protocol, userToken = null, path = null }) {

  return {
    apiKey,
    nodes: [
      {
        host,
        port,
        protocol,
        ...(path && { path }),
      },
    ],
    connectionTimeoutSeconds: 10,
    numRetries: 4,
    ...(userToken && {
      additionalHeaders: {
        userToken,
      },
    }),
  };
}

export const searchConfig = typesenseServerConfig({
  apiKey: import.meta.env.VITE_TYPESENSE_SEARCH_ONLY_API_KEY,
  host: import.meta.env.VITE_TYPESENSE_HOST === "localhost" ? window.location.hostname : import.meta.env.VITE_TYPESENSE_HOST,
  port: import.meta.env.VITE_TYPESENSE_PORT,
  protocol: import.meta.env.VITE_TYPESENSE_PROTOCOL,
});

export const dictionaryConfig = typesenseServerConfig({
  apiKey: import.meta.env.VITE_DICTIONARY_TYPESENSE_SEARCH_ONLY_API_KEY,
  host: import.meta.env.VITE_DICTIONARY_TYPESENSE_HOST,
  port: import.meta.env.VITE_DICTIONARY_TYPESENSE_PORT,
  protocol: import.meta.env.VITE_DICTIONARY_TYPESENSE_PROTOCOL,
  path: import.meta.env.VITE_DICTIONARY_TYPESENSE_PATH ? import.meta.env.VITE_DICTIONARY_TYPESENSE_PATH : null,
});
